import { PaginationItem, PaginationProps, Stack } from '@mui/material';
import { ForwardedRef, forwardRef, useState } from 'react';
import { useIntl } from 'react-intl';

import { phrasesMessages } from '../../translations/phrases.messages';
import { HBIcon } from '../HBIcon/HBIcon';
import {
  HBPaginationGotoButtonStyle,
  HBPaginationGotoInputStyle,
  HBPaginationRootStyle,
} from './HBPagination.styles';

export interface HBPaginationProps extends PaginationProps {
  gotoPage?: (page: number) => void;
}

export const HBPagination = forwardRef(
  <T extends HTMLDivElement>(
    {
      color = 'primary',
      variant = 'outlined',
      shape = 'rounded',
      gotoPage,
      ...props
    }: HBPaginationProps,
    ref: ForwardedRef<T>,
  ) => {
    const [pageNumber, setPageNumber] = useState('');
    const { formatMessage } = useIntl();
    const handleGotoPage = () => {
      if (!pageNumber || pageNumber == '0') return;
      if (
        pageNumber &&
        !isNaN(Number(pageNumber)) &&
        props.count &&
        Number(pageNumber) <= props.count
      ) {
        gotoPage?.(+pageNumber);
      }
    };

    return (
      <Stack direction="row" spacing={4} alignItems="center" className="paginationWrapper">
        {!!gotoPage && (
          <Stack direction="row" spacing={2} alignItems="center">
            <HBPaginationGotoButtonStyle
              variant={'contained'}
              color={'primary'}
              size="small"
              onClick={handleGotoPage}
            >
              {formatMessage(phrasesMessages.go)}
            </HBPaginationGotoButtonStyle>
            <HBPaginationGotoInputStyle
              size="small"
              placeholder={formatMessage(phrasesMessages.goTo)}
              value={pageNumber}
              onChange={(e) => setPageNumber(e.target.value)}
              maskOptions={{ mask: Number, min: 1 }}
              onKeyDown={(e) => e.key === 'Enter' && handleGotoPage()}
            />
          </Stack>
        )}

        <HBPaginationRootStyle
          ref={ref}
          color={color}
          variant={variant}
          shape={shape}
          renderItem={(items) => (
            <PaginationItem
              sx={{
                borderRadius: 2,
                justifyContent: 'center',
                alignItems: 'center',
              }}
              components={{
                previous: () => <HBIcon type={'angleLeft'} size="small" />,
                next: () => <HBIcon type={'angleRight'} size="small" />,
                first: () => <HBIcon type={'angleDoubleLeft'} size="small" />,
                last: () => <HBIcon type={'angleDoubleRight'} size="small" />,
              }}
              {...items}
            />
          )}
          {...props}
          onChange={(_, page) => {
            setPageNumber('');
            props?.onChange?.(_, page);
          }}
        />
      </Stack>
    );
  },
);

HBPagination.displayName = 'HBGridPagination';
// HBPagination.defaultProps = { siblingCount: 0, showFirstButton: true, showLastButton: true }
